import { ChangeEvent, useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { matchPath, useLocation } from 'react-router-dom';
import { Routes } from '@archiwum/routes';

type TabModel = {
  label: string;
  path: string;
};

const tabs = [
  {
    label: 'Generowanie paczki',
    path: Routes.PaczkaArchiwalna.path,
  },
  { label: 'Rejestr paczek', path: Routes.PaczkaArchiwalnaLista.path },
];

export const useArchivingPackageFacade = () => {
  const history = useHistory();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(tabs[0]);

  useEffect(() => {
    tabs.map((tab) => {
      if (matchPath(location.pathname, { path: tab.path, exact: true })) {
        setActiveTab(tab);
      }
    });
  }, [location.pathname]);

  const handleChangeTab = (event: ChangeEvent<unknown>, value: TabModel) => {
    history.push(value.path);
    setActiveTab(value);
  };

  return {
    tabs,
    activeTab,
    handleChangeTab,
  };
};
